import React, {useState, useContext, useEffect} from 'react'
import {Button, Col, Row, Table, Checkbox} from "antd";
import PurchaseStock from "../table-components/PurchaseStock";
import PurchaseQuantity from "../table-components/PurchaseQuantity";
import PurchaseUnit from "../table-components/PurchaseUnit";
import PurchaseShippingDate from "../table-components/PurchaseShippingDate";
import DeleteRow from "../table-components/deleteRow";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const PurchaseList = ({update = false}) => {
    const [uniqueKey, setUniqueKey] = useState(0)
    const [tableData, setTableData] = useState([])
    const {purchaseItems, updateDeleteCount} = useContext(PurchaseContext)
    const [purchaseItemList, setPurchaseItemList] = purchaseItems
    const [delCount] = updateDeleteCount

    useEffect(() => {
        if (purchaseItemList.length) {
            setUniqueKey(purchaseItemList.length)
        }
        setTableData(purchaseItemList)
    }, [purchaseItemList])

    const handleAddRow = () => {
        setPurchaseItemList([
            ...purchaseItemList,
            {
                key: uniqueKey + delCount,
                stock: '',
                quantity: 0,
                unit: '',
                shippingDate: new Date(),
                lock: true
            }
        ])
        setUniqueKey((uniqueKey) => uniqueKey + 1 + delCount)
    };

    const toggleLock = (rowIndex, lockStatus) => {
        const newList = replaceIndexAt(
            purchaseItemList,
            {
                ...purchaseItemList[rowIndex],
                lock: !lockStatus
            },
            rowIndex
        );
        setPurchaseItemList(newList);
    }

    const columns = [
        {
            title: '#',
            render: (t, r, i) => i + 1
        },
        {
            title: 'Stok Kilitle',
            render: (t, r, i) => <Checkbox checked={r.lock} onChange={() => toggleLock(i, r.lock)}/>
        },
        {
            title: 'Stok Adı',
            dataIndex: 'stock',
            key: 'stock',
            render: (t, r, i) => <PurchaseStock record={r} rowIndex={i}/>
        },
        {
            title: 'Miktar',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (t, r, i) => <PurchaseQuantity record={r} rowIndex={i}/>
        },
        {
            title: 'Birim',
            dataIndex: 'unit',
            key: 'unit',
            render: (t, r, i) => <PurchaseUnit record={r} rowIndex={i}/>
        },
        {
            title: 'Sevk Tarihi',
            dataIndex: 'shippingDate',
            key: 'shippingDate',
            render: (t, r, i) => <PurchaseShippingDate record={r} rowIndex={i}/>
        },
        {
            title: '',
            dataIndex: 'actions-column',
            key: 'action-column',
            render: (t, r, i) => <DeleteRow record={r} rowIndex={i}/>
        }
    ]

    return (
        <React.Fragment>
            <Row justify={'start'}>
                <Col span={8}>
                    <Button type={'link'} onClick={handleAddRow}>Yeni Ekle</Button>
                </Col>
            </Row>
            <Table size={'small'} columns={columns} dataSource={tableData} scroll={{x: 'max-content'}} pagination={false}/>
        </React.Fragment>
    )
}
export default PurchaseList